export const JobVatTypeConstants = {
    STANDARD: 'STANDARD',
    REVERSE: 'REVERSE',
    NOVAT: 'NOVAT'
};
